import * as S from "./InputCheckbox.style";
import { InputProps, Inputs } from "..";

interface InputCheckProps extends InputProps {
  name: string;
  data?: any;
  onChange?: (e: any) => void;
  value?: boolean;
}

export const InputCheckbox = ({
  label,
  required,
  data,
  name,
  onChange,
  value = false,
  size,
}: InputCheckProps) => {
  return (
    <Inputs
      label={label ? label : undefined}
      required={required ? required : false}
    >
      <S.InputCheckbox>
        {data.map((item: any, idx: number) => {
          if (value) {
            return (
              <S.Label key={idx}>
                <input
                  type="checkbox"
                  name={name}
                  value={item.value}
                  onChange={onChange}
                  checked={value}
                />
                {item.displayExpr}
              </S.Label>
            );
          }
          return (
            <S.Label key={idx} $size={size}>
              <input
                type="checkbox"
                name={name}
                value={item.value}
                onChange={onChange}
                // checked={value}
              />
              {item.displayExpr}
            </S.Label>
          );
        })}
      </S.InputCheckbox>
    </Inputs>
  );
};
